function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgChevronRight = function SvgChevronRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30 30",
    style: {
      enableBackground: "new 0 0 30 30"
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M10.6 14.7c0 1.6-1.1 2.7-2.7 2.7s-2.7-1.1-2.7-2.7V3.9H-5.5c-1.6 0-2.7-1.1-2.7-2.7s1.1-2.7 2.7-2.7H7.9c1.6 0 2.7 1.1 2.7 2.7v13.5z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "currentColor"
    },
    transform: "rotate(45 -2.778 22.364)"
  }));
};

export default SvgChevronRight;